import { css } from 'linaria';

export const kitchenGallerySectionTabs = css`
  && {
    margin-bottom: 32px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;

export const kitchenGalleryLoftStyle = css`
  && {
    @media (--from-tablet) {
      :nth-child(3) {
        grid-row: unset
      }
    }
  }
`;

export const kitchenGallerySectionMoreBtn = css`
  && {
    display: block;
    margin: 0 auto;

    @media (--only-mobile) {
      width: 100%;
      border-radius: var(--rounding-m);
    }
  }
`;
